/**
 * quarantine-configuration-response.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

export class QuarantineConfigurationResponse extends IncomingMessage
{
    public tag : MessageTag = MessageTag.RSP_CFG_QUARANTINE;

    public lockPending : boolean;
    public secondsTillLock : number;

    public static StandardMessage : string =
        " minutes until the application is locked (approximate). Please save your work.";
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/quarantine-configuration-response.ts